import { setRuntimeConfig } from './runtimeConfig';

(async function() {
  const authinfo = await fetch('/authinfo')
    .then(resp => resp.json())
    .then(response => {
      return {
        bouncerConfiguration: {
          bouncerEnabled: response.bouncerEnabled,
          audience: response.audience,
          domain: response.domain,
          clientId: response.clientId,
          connection: response.connection
        },
        featureFlags: response.featureFlags || {}
      };
    });

  setRuntimeConfig(authinfo);

  await import('./app');
})();
